/**
 * LOS TITULOS — regla de Faina (25-ago):
 * en un titulo, toda palabra de DOS O MAS LETRAS empieza con mayuscula.
 * Las de una sola letra —y, o, a, e, u— se quedan en minuscula.
 *
 *   «El asombro»                    ->  «El Asombro»
 *   «El don de sanar a otros»       ->  «El Don De Sanar a Otros»
 *   «La luz siempre triunfa...»     ->  «La Luz Siempre Triunfa...»
 *
 * Se aplica al MOSTRAR, no en el documento: el titulo original se conserva
 * intacto en el Word y en los datos.
 */

/** Palabras que ya vienen escritas asi y no deben tocarse. */
const RESPETAR = new Set(['ONG', 'TdL', 'YO', 'SOY']);

const capitalizar = (palabra) => {
  if (!palabra) return palabra;
  if (RESPETAR.has(palabra)) return palabra;

  // Las de una sola letra se quedan como estan.
  const letras = palabra.replace(/[^\p{L}]/gu, '');
  if (letras.length < 2) return palabra;

  // La mayuscula va en la primera LETRA, saltando comillas, parentesis o guiones.
  const i = palabra.search(/\p{L}/u);
  if (i === -1) return palabra;
  return palabra.slice(0, i) + palabra[i].toLocaleUpperCase('es') + palabra.slice(i + 1);
};

/**
 * Devuelve el titulo con la regla aplicada. Respeta los signos que separan
 * palabras —espacios, guiones, barras— y lo que va tras dos puntos.
 */
export const formatoTitulo = (titulo = '') =>
  titulo.split(/(\s+|[-/])/).map((trozo) =>
    /^(\s+|[-/])$/.test(trozo) ? trozo : capitalizar(trozo)
  ).join('');

export default formatoTitulo;
